import { useMemo, useState } from 'react';
import { FaWhatsapp, FaTelegramPlane, FaFacebookF } from 'react-icons/fa';
import LegalModal from '@/components/common/LegalModal';
import { legalPages, legalPagesByLabel, type LegalPageId } from '@/content/legal';
import useContactSupport from '@/hooks/useContactSupport';

const footerLinks = [
  'Privacy Policy',
  'Terms and Conditions',
  'Rules and Regulations',
  'KYC',
  'Responsible Gaming',
];

export function Footer() {
  const [activePageId, setActivePageId] = useState<LegalPageId | null>(null);
  const { handleWhatsAppSupportClick, handleTelegramSupportClick } = useContactSupport();

  const activePage = useMemo(
    () => legalPages.find((page) => page.id === activePageId) ?? null,
    [activePageId]
  );

  return (
    <>
      <footer className="px-4 pb-4">
        {/* APK Download */}
        <div className="mt-10 flex flex-col items-center text-center">
          <button className="">
            <img
              src="/images/btn-android-dl.png"
              alt="Download APK"
              className="w-[9.375rem] h-auto"
            />
          </button>

          <span className="mt-1 text-sm font-semibold text-[#6B7280]">
            v1.11 - 2024/3/8 - 2.6MB
          </span>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center py-5">
          <div className="flex items-center gap-5">
            <SocialButton onClick={handleWhatsAppSupportClick}>
              <FaWhatsapp className="size-7" />
            </SocialButton>

            <SocialButton onClick={handleWhatsAppSupportClick}>
              <FaWhatsapp className="size-7" />
            </SocialButton>

            <SocialButton onClick={handleTelegramSupportClick}>
              <FaTelegramPlane className="size-6" />
            </SocialButton>

            <SocialButton onClick={() => {}}>
              <FaFacebookF className="size-6" />
            </SocialButton>
          </div>
        </div>

        {/* Footer Links */}
        <div className="text-center">
          <ul className="flex flex-wrap items-center justify-center">
            {footerLinks.map((item, index) => {
              const page = legalPagesByLabel[item];

              if (!page) return null;

              return (
                <li key={item} className="inline-flex items-center pb-2">
                  <button
                    type="button"
                    onClick={() => setActivePageId(page.id)}
                    className="px-2 text-[0.813rem] leading-none text-[#1F2937]"
                  >
                    {item}
                  </button>

                  {index !== footerLinks.length - 1 && <span className="text-[#D1D5DB]">|</span>}
                </li>
              );
            })}
          </ul>
        </div>
      </footer>

      <LegalModal
        isOpen={activePage !== null}
        title={activePage?.title ?? ''}
        Content={activePage?.Content}
        onClose={() => setActivePageId(null)}
      />
    </>
  );
}

interface SocialButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

function SocialButton({ onClick, children }: SocialButtonProps) {
  return (
    <button
      onClick={onClick}
      className="
        flex h-[2.375rem] w-[2.375rem] items-center justify-center rounded-full bg-black text-xl text-white transition-transform duration-200 hover:scale-105"
    >
      {children}
    </button>
  );
}
